let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7x8iZ")).then(() => parcelRequire('1l2tN'));